// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

export const Assets: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <rect x="4" width="8" height="2" rx="1" />
        <rect x="3" y="13" width="10" height="2" rx="1" />
        <path d="M6.07225 4.85166C6.14568 4.36214 6.56619 4 7.06119 4H8.93881C9.43381 4 9.85432 4.36214 9.92775 4.85166L10.8277 10.8517C10.9184 11.4563 10.4502 12 9.83881 12H6.16119C5.54982 12 5.08156 11.4563 5.17225 10.8517L6.07225 4.85166Z" />
        <path d="M5 2H11C11 2.55228 10.5523 3 10 3H6C5.44772 3 5 2.55228 5 2Z" />
      </g>
    </SvgIcon>
  );
};
